export default __webpack_public_path__ + "static/media/akan-man-gold.ebcf6999.png";